import { UIText1, IconClose16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IMyHomeBannerProps {
  onClose(): void;
}

export const MyHomeBanner: React.FC<IMyHomeBannerProps> = ({ onClose }) => {
  return (
    <div data-testid="MyHomeBanner" className={styles['container']}>
      <div className={styles['content']}>
        <UIText1>
          Оценка переехала в Мой дом, ваши объекты теперь там.{' '}
          <a href="https://www.cian.ru/my-home/main" className={styles['link']}>
            Посмотреть
          </a>
        </UIText1>
      </div>
      <button type="button" className={styles['close']} onClick={onClose}>
        <IconClose16 />
      </button>
    </div>
  );
};

MyHomeBanner.displayName = 'MyHomeBanner';
